export default __webpack_public_path__ + "static/media/welcome-dashboard-family-visitor.ba901c8c.png";